import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const BoxDevices = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 90px;
`;

export const ListDevices = lib.styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px;
  position: relative;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    div {
      display: flex;
      flex: 1;
      max-height: 1px;
      min-height: 1px;
      background-color: ${colors.lightGray06};
      opacity: 0.5;
    }
    span {
      font-size: 12px;
      color: ${colors.black};
      opacity: 0.5;
      margin-left: 5px;
      margin-right: 5px;
      font-weight: 600;
    }
  }

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 15px;
    cursor: pointer;

    .active {
      color: ${colors.lightBlue};
    }
    div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex: 1;

      span {
        font-size: 12px;
        padding-left: 20px;
      }
    }

  }
`;

export const BoxSelect = lib.styled.div`
  width: 100%;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${colors.white02};
  border: 1px solid ${colors.lightGray06};
  border-radius: 10px;

  .inputSelect {
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 0;
    font-size: ${fonts.default}px;
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 0px 3px 0 3px;

    &::before {
      border-bottom: 0!important;
    }

    &::after {
      border-bottom: 0!important;
    }

    .MuiSelect-select:focus {
      background-color: inherit;
    }

    div {
      width: 290px;
      margin-top: 4px;
    }
  }
`;

export const VolumeComponent = lib.styled.div`
  display: flex;
  width: 300px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: -3px;
  padding-bottom: 5px;
`;
